import {Security} from '@okta/okta-react';
import {useNavigate} from 'react-router-dom';
import {OktaAuth, toRelativeUrl} from '@okta/okta-auth-js';

const options = {
  issuer: window.env?.OKTA_ISSUER,
  clientId: window.env?.OKTA_CLIENT_ID,
  redirectUri: `${window.location.origin}/login/callback`,
  scopes: [
    'openid',
    'profile',
    'email',
    'api.wellsky.payer.wscc.payerhub.admin',
  ],
};
const oktaAuth = new OktaAuth(options);

export const SecurityProvider = ({children}) => {
  const navigate = useNavigate();

  const restoreOriginalUri = (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin), {
      replace: true,
    });
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
};
